<template>
    <v-dialog v-model="isModalVisible" max-width="400px">
        <v-card :loading="loading" class="border-lg border-primary border-opacity-100">
            <v-card-title class="d-flex justify-center align-center">
                <v-img src="logo.png" alt="Logo" max-width="65px" max-height="65px" class="mr-3" />
                <span class="text-h3 text-primary">LOGIN</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
                <v-form @submit.prevent="checkLogin" ref="loginForm" @keydown.enter="checkLogin">
                    <v-text-field color="primary" label="Email" v-model="logIn.email" type="email" :rules="emailRules"
                        required outlined></v-text-field>
                    <v-text-field color="primary" label="Password" v-model="logIn.password" append-icon="mdi-eye"
                        @click:append="showPassword = !showPassword" :type="showPassword ? 'text' : 'password'" required
                        outlined></v-text-field>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-btn class="w-100" variant="elevated" color="primary" @click="checkLogin">Login</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import { useUserStore } from '@/store/userStore';
import { ref, computed } from 'vue';
import { emailRules } from './admin/forms/rules/user';

// Props
const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    }
});


const emit = defineEmits();
const loginForm = ref();
const showPassword = ref(false);
const logIn = ref({
    email: '',
    password: '',
});

const loading = ref(false);

const isModalVisible = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit('update:modelValue', value);
    }
});


const checkLogin = async () => {
    const isValid = await loginForm.value?.validate();
    if (isValid.valid) {
        if (isValid) {
            loading.value = true;
            try {
                await useUserStore().logIn(logIn.value.email, logIn.value.password);
                loading.value = false;
                emit('close');
            } catch (error) {
                loading.value = false;
                console.error("Error en la validación o creación del usuario:", error);
            }
        } else {
            console.log("Formulario no válido");
        }
    };
}
</script>
